import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import TechAgenda from "./TechAgenda";
import TechVisit from "./TechVisit";
import "./field.css";

export default function TechApp() {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]'); const original = link?.getAttribute("href");
    const theme = document.querySelector('meta[name="theme-color"]'); const originalTheme = theme?.getAttribute("content");
    const originalTitle = document.title;
    link?.setAttribute("href", "/manifest-tech.json"); theme?.setAttribute("content", "#0A0A0A"); document.title = "All Active · Terreno";
    return () => { if (original) link?.setAttribute("href", original); if (originalTheme) theme?.setAttribute("content", originalTheme); document.title = originalTitle; };
  }, []);
  return <div className="field-app"><Routes><Route index element={<Navigate to="agenda" replace />} /><Route path="agenda" element={<TechAgenda />} /><Route path="servicio/:id" element={<TechVisit />} /><Route path="*" element={<Navigate to="/tecnicos/agenda" replace />} /></Routes></div>;
}